import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './ConfirmationAfterUploadModal.css';

class ConfirmationAfterUploadModal extends React.Component {
  render() {
    const { onConfirm, onCancel, show, header, body } = this.props;

    return (
      <Modal show={show} dialogClassName={`${styles.dialog} modal-dialog`}>
        <Modal.Header>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default" onClick={onCancel}>
            Re-upload
          </button>
          <button className="btn btn-primary" onClick={onConfirm}>
            Confirm Import
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmationAfterUploadModal.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  header: PropTypes.object,
  body: PropTypes.object,
};

export default ConfirmationAfterUploadModal;
